module.exports = __webpack_public_path__ + "img/End-of-Time.36a72dab.png";